import { InteractionMetric } from "@edgetier/watchtower-types";
import { EXPERIENCE_SCORE_METRIC_ENABLED } from "constants/feature-flags";
import { useInteractionMetricsAvailable } from "./use-interaction-metrics-available";

/**
 * Loop through the available interaction metrics from backend, remove the excluded metrics,
 * disabled filter flags
 * @param excludedMetrics List of excluded interaction metrics
 * @returns Visible metrics
 */
export const useFilterAvailableMetrics = (excludedMetrics: InteractionMetric[]) => {
    const { data: interactionMetricsAvailable } = useInteractionMetricsAvailable(
        {},
        {
            select: (metrics) => {
                return Object.fromEntries(
                    Object.entries(InteractionMetric).filter(
                        ([_, metric]) =>
                            metrics[metric] &&
                            !excludedMetrics.includes(metric) &&
                            (metric !== InteractionMetric.ExperienceScore || EXPERIENCE_SCORE_METRIC_ENABLED)
                    )
                );
            },
        }
    );

    if (typeof interactionMetricsAvailable === "undefined") return {};

    return interactionMetricsAvailable;
};
